import {RouteRecordRaw} from "vue-router";
import AuthMiddleware from "@/router/middleware/AuthMiddleware";
import UserAuthMiddleware from "@/router/middleware/UserAuthMiddleware";
import {ModuleList} from "@/models/settings/ModuleList";
import {PermissionList} from "@/models/settings/PermissionList";
import ModuleMiddleware from "@/router/middleware/ModuleMiddleware";


const moduleToDoRoutings: Array<RouteRecordRaw> = [
    {
        name: "todo",
        path: "modules/todo",
        component: () => import("@/views/modules/aufgabenplanung/ToDoPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)
            ],
        },
    },
    {
        name: "todo-detail",
        path: "modules/todo/:id",
        component: () => import("@/views/modules/aufgabenplanung/ToDoDetailsPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
     {
        name: "todo-collection-detail",
        path: "modules/todos/collection/:collectionId",
        component: () => import("@/views/modules/aufgabenplanung/ToDoCollectionDetailPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-tasks",
        path: "modules/todo/:id/tasks",
        component: () => import("@/views/modules/aufgabenplanung/tasks/ToDoTasksPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-tasks-detail",
        path: "modules/todo/:toDoId/tasks/:taskId",
        component: () => import("@/views/modules/aufgabenplanung/tasks/ToDoTasksDetailsPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-tasks-edit",
        path: "modules/todo/:toDoId/tasks/:taskId/edit",
        component: () => import("@/views/modules/aufgabenplanung/tasks/ToDoTasksEditPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-tasks-add",
        path: "modules/todo/:id/tasks/add",
        component: () => import("@/views/modules/aufgabenplanung/tasks/AddToDoTaskPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-reports-add",
        path: "modules/todo/:id/reports/add",
        component: () => import("@/views/modules/aufgabenplanung/reports/AddToDoReportPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-checklist-add",
        path: "modules/todo/:id/reports/addChecklist",
        component: () => import("@/views/modules/aufgabenplanung/reports/AddTodoChecklistPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-documents",
        path: "modules/todo/:id/documents",
        component: () => import("@/views/modules/aufgabenplanung/documents/ToDoDocumentsPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-documents-add",
        path: "modules/todo/:id/documents/add",
        component: () => import("@/views/modules/aufgabenplanung/documents/AddToDoDocumentsPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-documents-detail",
        path: "modules/todo/:toDoId/documents/:documentId",
        component: () => import("@/views/modules/aufgabenplanung/documents/ToDoDocumentsDetailsPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
    {
        name: "todo-detail-documents-detail-file-preview",
        path: "modules/todo/:toDoId/documents/:documentId/preview",
        component: () => import("@/views/modules/aufgabenplanung/documents/ToDoDocumentsDetailsFilePreviewPage.vue"),
        meta: {
            middleware: [
                new AuthMiddleware(),
                new ModuleMiddleware(ModuleList.TODO),
                new UserAuthMiddleware(ModuleList.TODO, PermissionList.MODULE_TODO)],
        },
    },
];

export default moduleToDoRoutings;
